import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class AppPageService {
  private _baseTitleString = 'Michigan Property Management | Rental Property Management Company in Michigan';
  constructor(
    protected titleService: Title,
    protected activatedRoute: ActivatedRoute,
  ) {
    // If title is available in the activated route's data object then include it in the document title
    if (activatedRoute.snapshot.data && activatedRoute.snapshot.data.title) {
      this.setTitle(`${activatedRoute.snapshot.data.title} | ${this._baseTitleString}`);
    }
  }
  /**
   * Set the title of the current HTML document.
   * @param newTitle 
   */
  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
  /**
   * @returns Get the title of the current HTML document.
   */
  public getTitle() {
    this.titleService.getTitle();
  }
}
